document.addEventListener("DOMContentLoaded", function () {
  // Wait a bit for the theme's quantity counter to initialize
  setTimeout(function () {
    const quantityInputs = document.querySelectorAll("[data-quantity-field]");

    quantityInputs.forEach(function (input) {
      const moqValue = parseInt(input.getAttribute("min")) || 1;
      const currentValue = parseInt(input.value) || 1;

      // If current value is less than MOQ, set it to MOQ
      if (currentValue < moqValue) {
        input.value = moqValue;

        // Trigger change event to update any related functionality
        const event = new Event("input", { bubbles: true });
        input.dispatchEvent(event);
      }
    });

    // Also update any quantity selectors (dropdown displays)
    const quantitySelectors = document.querySelectorAll(
      "[data-quantity-select]"
    );
    quantitySelectors.forEach(function (selector) {
      const input = selector
        .closest("[data-popout]")
        .querySelector("[data-quantity-field]");
      if (input) {
        const moqValue = parseInt(input.getAttribute("min")) || 1;
        selector.textContent = moqValue;
      }
    });
  }, 100); // Small delay to ensure theme JS has initialized
});

// Override the quantity counter initialization if needed
document.addEventListener("theme:loaded", function () {
  const quantityHolders = document.querySelectorAll("[data-quantity-holder]");

  quantityHolders.forEach(function (holder) {
    const input = holder.querySelector("[data-quantity-field]");
    if (input) {
      const moqValue = parseInt(input.getAttribute("min")) || 1;
      const currentValue = parseInt(input.value) || 1;

      if (currentValue < moqValue) {
        input.value = moqValue;

        // Update the display if there's a quantity selector
        const quantitySelector = document.querySelector(
          "[data-quantity-select]"
        );
        if (quantitySelector) {
          quantitySelector.textContent = moqValue;
        }
      }
    }
  });
});
